import UserMonthlyReportList from "@components/modules/reports/user-monthly-report/List";
import { NavigationReports } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import type { NavigationReportsProps } from "@src/components/widgets/AppSubNav/NavigationReports/NavigationReports";
import { DemoModule, Modules } from "@src/components/widgets/DemoModule";
import { createFileRoute } from "@tanstack/react-router";

const report: NavigationReportsProps["currentReport"] = {
  href: "/reports/user-monthly-report",
  title: () => t`Users monthly report`,
};

const Page = () => (
  <MainLayout
    title={report.title()}
    navigation={<NavigationReports currentReport={report} />}
  >
    <DemoModule module={Modules.Reports}>
      <UserMonthlyReportList />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/reports/user-monthly-report")({
  component: Page,
});
